import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { FILE_TYPE_FEEDBACK_REPORT } from '@/lib/constant';

export interface FeedbackState {
    /** 反馈列表 */
    reportList: Feedback.Report[];
    categoryList: Feedback.Category[] | null;
    questionList: {
        hot: Feedback.QA[] | undefined,
        [categoryId: string]: Feedback.QA[] | undefined,
    };
    qrcode: {
        [activityId: number]: string | undefined,
    };
}

const m: Module<FeedbackState, RootState> = {
    namespaced: true,
    state: () => ({
        reportList: [],
        categoryList: null,
        questionList: {
            hot: [],
        },
        qrcode: {},
    }),
    mutations: {
        setCategoryList(state, categoryList) {
            state.categoryList = categoryList;
        },
        /**
         * 获得问题列表
         */
        setQuestionList(state, { categoryId, isHot, questionList }) {
            if (isHot) {
                Vue.set(state.questionList, 'hot', questionList);
            } else {
                Vue.set(state.questionList, categoryId, questionList);
            }
        },
        /**
         * 记录report
         */
        setReportList(state, reports) {
            state.reportList = reports;
        },
        /**
         * 记录qrcode
         */
        setQrcode(state, { activityId, qrcode }) {
            Vue.set(state.qrcode, activityId, qrcode);
        },
    },
    actions: {
        /**
         * 获得category列表
         */
        async getCategoryList({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/question/category_list');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setCategoryList', rdata.data);
            }
            return rdata;
        },
        async getQuestionList({ state, commit }, { categoryId, isHot, forceUpdate }) {
            if (state.questionList[categoryId] && !forceUpdate) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/question/question_list', {
                params: {
                    category_id: categoryId,
                    is_hot: isHot,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setQuestionList', {
                    categoryId,
                    isHot,
                    questionList: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 上报数据
         * @param attachments [fileId]
         */
        async report({ state, commit, dispatch }, { contact, type, content, attachments, signInId }: { contact: string, type: Feedback.ReportType, content: string, attachments?: string[], signInId?: string }) {
            const response = await Vue.axios.post('/api/v1/question/feedback', {
                contact,
                type,
                content,
                attachments,
                sign_in_id: signInId,
            });
            return response.data;
        },
        /**
         * 获取反馈列表
         */
        async getReportList({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/question/feedback');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setReportList', rdata.data);
            }
            return rdata;
        },
        /**
         * 查询
         */
        async query({ state, commit }, { word }) {
            const response = await Vue.axios.get('/api/v1/question/query', {
                params: {
                    word,
                },
            });
            return response.data;
        },
        /**
         * 获取二维码
         */
        async getQrcode({ state, commit }, { activityId }) {
            if (state.qrcode[activityId]) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/question/question_qr_code', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setQrcode', {
                    activityId,
                    qrcode: rdata.data ? rdata.data.qr_code : null,
                });
            }
            return rdata;
        },
    },
};

export default m;
